// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const CubeIcon = /* @__PURE__ */ createIcon(
  'cube',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'm20 8.699-7 3.89v7.71l6.691-3.715a6 6 0 0 0 .3-.172l.003-.004.001-.005c.004-.068.005-.161.005-.344zM11.995 3.15c-.058.028-.135.071-.286.155L5.059 7 12 10.855 18.94 7l-6.649-3.694c-.151-.084-.228-.127-.286-.155L12 3.148zm-7.99 13.252v.005l.005.004c.057.036.139.083.299.172L11 20.299v-7.71l-7-3.89v7.36c0 .183 0 .276.005.344M22 16.279a2.5 2.5 0 0 1-.1.76 2 2 0 0 1-.43.728c-.243.265-.568.432-.807.565l-7.4 4.111c-.227.126-.524.303-.86.372a2 2 0 0 1-.806 0c-.336-.07-.633-.246-.86-.372l-7.4-4.111c-.24-.133-.564-.3-.808-.565a2 2 0 0 1-.428-.727A2.5 2.5 0 0 1 2 16.279V7.72c.002-.234.016-.503.1-.76.09-.27.236-.519.43-.728.243-.265.568-.431.807-.564l7.4-4.112c.227-.126.524-.303.86-.372.199-.04.404-.052.605-.031l.201.031.124.03c.285.082.537.232.736.342l7.4 4.112c.24.133.564.3.808.564a2 2 0 0 1 .35.53l.078.199.037.128c.052.217.062.436.064.631z',
      },
    ],
  ]
);
